export enum EnumTipoPropagandaLocal {
    Ambos = 0,
    Pdv = 1,
    Retaguarda = 2,   
}